import React from "react";
import "./footer.scss";

import { observer } from "mobx-react-lite";
import logo from "../../assets/images/logo.svg";
import menuStore from "../../stores/menu_store/menu_store";

function Footer() {
	const goTo = (url: string) => (window.location.href = url);
	return (
		<footer className="footer flex">
			<div
				className="footer__logo"
				onClick={() => (window.location.href = "/")}
			>
				<img src={logo} alt="" />
			</div>

			<ul className="footerMenu flex">
				{menuStore.menuItems &&
					menuStore.menuItems.map((item, index) => (
						<li key={index}>
							<span onClick={() => goTo(item[1])}>{item[0]}</span>
						</li>
					))}
			</ul>
		</footer>
	);
}

export default observer(Footer);
